<template>
  <div class="task-index">
    <Stack
      gap="4"
      class="body"
    >
      <header class="header">
        <Title>{{ title }}</Title>
        <!-- <Tabs class="tabs-wrap">
          <TabsList>
            <TabItem
              :active="tab === 'list'"
              @click="tab = 'list'"
            >
              List View
            </TabItem>
            <TabItem
              :active="tab === 'kanban'"
              @click="tab = 'kanban'"
            >
              Kanban Board
            </TabItem>
          </TabsList>
        </Tabs> -->

        <!-- Search disabled until the backend for it is ready -->
        <!--
        <Buttons gap="2">
          <form
            class="search-form"
            @submit.prevent="performSearch"
          >
            <TextInput
              v-model="searchInput"
              placeholder="Search"
              size="3_5"
              icon-before="fas fa-search"
              :disabled="isLoading"
            />

            <Button
              size="3_5"
              :disabled="isLoading"
            >
              Search
            </Button>
          </form>
        </Buttons>
        -->
      </header>

      <div
        v-if="!areFiltersEmpty(taskStore.tasks.filters)"
        class="active-filters"
      >
        <ActiveFilter
          v-for="[key, value] in activeFilters"
          :id="key"
          :key="key"
          :filter="value"
        />
        <!--
        <Badge
          clickable
          status="ghost"
          @click="taskStore.resetTaskFilters()"
        >
          Reset All
        </Badge> -->
      </div>

      <LoaderWithText v-if="isLoading" />

      <template v-else-if="groupedAndSortedTasks.length">
        <TaskList
          v-if="tab ==='list'"
          :tasks="groupedAndSortedTasks"
        />

        <TaskKanbanBoard
          v-if="tab ==='kanban'"
          :tasks="groupedAndSortedTasks"
        />
      </template>

      <Stack
        v-else
        gap="2"
      >
        <p>No results</p>
        <div>
          <Button @click="taskStore.resetTaskFilters()">
            Reset Search
          </Button>
        </div>
      </Stack>
    </Stack>

    <aside class="side">
      <TaskSidebar
        v-if="taskStore.tasks.hasFetched"
        :is-loading="isLoading"
      />
    </aside>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Badge, Button, Buttons, LoaderWithText, Stack, Title, TextInput } from '@stakeui';
import TaskList from './TaskList.vue';
import TaskKanbanBoard from './TaskKanbanBoard.vue';
import TaskSidebar from './TaskSidebar.vue';
import ActiveFilter from '../ActiveFilter.vue';
import { useTaskStore } from '@frontend/ui/stores/taskStore.js';
import { areFiltersEmpty } from '../filterUtils.js';

const taskStore = useTaskStore();

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
});

const tab = ref('list');
const searchInput = ref('');
const priorityOrder = {
  critical: 1,
  high: 2,
  medium: 3,
  low: 4,
};

const isLoading = computed(() => {
  return taskStore.tasks.isFetching || !taskStore.tasks.hasFetched;
});

const groupedAndSortedTasks = computed(() => {
  if (!taskStore.tasks.items) {
    return [];
  }

  // Step 1: Group tasks by priority
  const groups = taskStore.tasks.items
      .slice()
      .reduce((acc, task) => {
        const priority = task.priority || 'unknown';
        if (!acc[priority]) acc[priority] = [];
        acc[priority].push(task);
        return acc;
      }, {});

  // Step 2: Convert object to array and sort by priorityOrder
  return Object.keys(groups)
      .map(priority => ({
        priority,
        tasks: groups[priority].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)), // Optional: sort tasks by dueDate
      }))
      .sort((a, b) => (priorityOrder[a.priority] || 99) - (priorityOrder[b.priority] || 99));
});

const activeFilters = computed(() => {
  return Object.entries(taskStore.tasks.filters).filter(([_, value]) => {
    if (typeof value === 'string') return value.trim() !== '';
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'boolean') return value === true;
    return false;
  });
});

const performSearch = () => {
  taskStore.tasks.filters.search = searchInput.value;
  taskStore.fetchTasks();
};

onMounted(() => {
  taskStore.setStatus(props.status);
  performSearch();
});
</script>

<style scoped>
.task-index {
  gap: 2rem;
  display: grid;
  grid-template-columns: 1fr 16rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1em;
}

.active-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
}

.tabs-wrap {
  flex-grow: 1;
}

.controls {
  display: flex;
  gap: 0.5em;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 0.25em;
}
</style>
